import type { TimelineSpec } from './timeline.js';

/**
 * Apollo 11, in mission elapsed time. Positions come from the hour value, so
 * the rail shows what a numbered list cannot: the landing and the first
 * footstep are six and a half hours apart, and both sit in the last third of an
 * eight-day mission that was mostly coasting.
 */
export function timelineFixture(width = 640, focusEventId = 'first-step'): TimelineSpec {
  return {
    id: 'apollo-11-mission',
    family: 'primitive-timeline',
    view: 'sequence',
    viewport: { width, height: 470 },
    subject: 'Apollo 11',
    unit: 'h',
    events: [
      { id: 'launch', label: 'Launch', at: 0, clock: '000:00', detail: '16 July 1969' },
      { id: 'lunar-orbit', label: 'Lunar orbit', at: 75.83, clock: '075:50' },
      { id: 'touchdown', label: 'Touchdown', at: 102.76, clock: '102:46' },
      { id: 'first-step', label: 'First step', at: 109.41, clock: '109:25' },
      { id: 'lunar-liftoff', label: 'Lunar liftoff', at: 124.37, clock: '124:22' },
      { id: 'splashdown', label: 'Splashdown', at: 195.31, clock: '195:19', detail: '24 July 1969' },
    ],
    spans: [
      { id: 'outbound', label: 'Coasting out', from: 'launch', to: 'touchdown' },
      { id: 'surface', label: 'On the surface', from: 'touchdown', to: 'lunar-liftoff' },
    ],
    focusEventId,
    title: 'Six hours between landing and the first footstep',
    subtitle: 'Order alone would hide the shape of the mission; the rail is elapsed time, so the gaps carry the argument.',
    provenance: 'Apollo 11 mission elapsed times (hours:minutes) from the NASA mission timeline; launch 16 July 1969, 13:32 UTC',
  };
}
